import React from 'react';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/new' },
  { label: 'Assigned', to: '/user/case/new' },
];
const NewCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.new_case_list_title}
          breadCrumbItems={BREAD_CRUMBS}
          showHasFilter = {true}
        />
      </div>
    </div>
  );
};

export default NewCases;
